import { Link } from "react-router-dom";

interface BreakingTickerProps {
  items: { id: string; title: string }[];
}

export default function BreakingTicker({ items }: BreakingTickerProps) {
  const loop = [...items, ...items];

  return (
    <div className="flex items-center gap-3 overflow-hidden bg-foreground-950 py-2 pl-4 text-background-50 md:pl-6">
      <span className="flex shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
        <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-background-50" />
        突发
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track">
          {loop.map((item, index) => (
            <Link
              key={`${item.id}-${index}`}
              to={`/article/${item.id}`}
              className="mr-8 inline-flex items-center gap-2 whitespace-nowrap text-xs text-background-300 transition hover:text-accent-400 md:text-sm"
            >
              <i className="ri-scales-3-line text-accent-400" />
              {item.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}